import Steps from './steps'
import { UserDetailFormInterface } from './interfaces'

export default function UserDetailForm(props: UserDetailFormInterface) {
  return <Steps {...props} />
}
